const usingServiceAdvantage = {
  en: {
    title: 'The Best POS System for Quick Service Restaurants',
    desc: 'Quick service needs fast tech! Make ordering & payment easy for guests and staff.',
    items: [
      {
        title: 'User Friendly, Self-Ordering Tech',
        image: `${process.env.ASSETS_PREFIX}/businesstype/customers-ordering-from-boba-shop-kiosk-pos.jpeg`,
        items: [
          {
            desc: 'Browse and order menu items with ease',
          },
          {
            desc: 'Update your digital menus with a few clicks – no more print costs!',
          },
          {
            desc: 'Multi-language selection available!',
          },
        ],
      },
      {
        title: 'Cut Wait Times ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/happy-boba-tea-customer.jpg`,
        items: [
          {
            desc: 'Minimize lines with customer orders flying directly to the kitchen.',
          },
          {
            desc: 'Minimize wait times as guests self-serve and order via QR code, online or kiosks.',
          },
          { desc: 'Use automated SMS to notify guests when orders are ready.' },
        ],
      },
      {
        title: 'Quick Boost to Profits',
        image: `${process.env.ASSETS_PREFIX}/businesstype/quick-service-kiosk-loyalty.jpeg`,
        items: [
          {
            desc: 'Faster processes create better customer experiences and more returning guests!',
          },
          {
            desc: 'Our POS system saves the average restaurant up to $8,000/month in labor costs',
          },
          {
            desc: 'Use our loyalty, CRM, and gift card programs to turn one-time customers into your regulars!',
          },
        ],
      },
    ],
  },
  zh: {
    title: '优质的POS产品帮助您提供高质量的餐饮服务',
    desc: 'Chowbus POS一站式解决方案帮助您显著提升客户体验和餐厅经营效率。',
    items: [
      {
        title: '升级顾客体验',
        image: `${process.env.ASSETS_PREFIX}/businesstype/customers-ordering-from-boba-shop-kiosk-pos.jpeg`,
        items: [
          {
            desc: '有双语电子菜单供顾客选择，顾客可以通过图片和描述更好地了解菜品',
          },
          {
            desc: '顾客可以通过智能点单机点单，实现从下单到支付的全自助服务',
          },
          {
            desc: '餐厅通过自动化短信服务通知顾客餐品完成，提升顾客的等餐体验',
          },
        ],
      },
      {
        title: '减少等待时间',
        image: `${process.env.ASSETS_PREFIX}/businesstype/happy-boba-tea-customer.jpg`,
        items: [
          {
            desc: '线上取号了解排队时间，短信提醒到店用餐，减少顾客等位时间',
          },
          {
            desc: '顾客可以使用智能自助点餐机、网页等自助下单，减少等待点餐的时间',
          },
          {
            desc: '顾客一键下单，订单直达后厨，减少顾客等待餐品的时间',
          },
        ],
      },
      {
        title: '提升餐厅利润',
        image: `${process.env.ASSETS_PREFIX}/businesstype/quick-service-kiosk-loyalty.jpeg`,
        items: [
          {
            desc: 'Chowbus POS帮助您在点单、结账、订单管理等环节显著减少人力成本',
          },
          {
            desc: '关注顾客复购率，善用会员、积分、礼品卡、营销短信等方式发展您的回头客，提升营业额',
          },
          {
            desc: '更快的服务、更优的顾客体验有效提升顾客的复购率及营业额',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
